import api from './api';
import { ZipcodeSnapshot } from '../models/AutoFill/Zipcode';
import { getBackVersion } from '../config';

const getAddressByZipcode = (zipcode: string): Promise<ZipcodeSnapshot> =>
    api.request<ZipcodeSnapshot>({
        method: 'GET',
        url: `${getBackVersion()}/zipcodes/${zipcode}`,
    });

export default { getAddressByZipcode };
